import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContentTypeSectionStructure,
  BackendQueryLongFormSectionsForContentTypeArgs,
} from 'src/types/backend';

const QUERY = gql`
  query LongFormSectionsForContentType($contentType: LongFormContentTypeEnum!) {
    longFormSectionsForContentType(contentType: $contentType) {
      assetType
    }
  }
`;

type Variables = BackendQueryLongFormSectionsForContentTypeArgs;
type Result = Pick<BackendContentTypeSectionStructure, 'assetType'>[];

export const queryLongFormSectionsForContentType = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(response.data);
};
